import { IChatWidgetData, IChatWidgetStyle } from "@pageBuilder/typings";
import { WidgetRendererBase } from "./widget-renderer-base";

export class ChatWidgetRenderer extends WidgetRendererBase<IChatWidgetData> {

    protected createNewInternal(): HTMLElement {
        return this.createWidgetElement("chatWidget");
    }

    protected renderInternal(element: HTMLElement, data: IChatWidgetData): HTMLElement {
        delete element.dataset.snippet;
        delete element.dataset.channelId;
        delete element.dataset.renderedHtml;

        let content = element.querySelector<HTMLElement>(".widget-content");
        if (!content) {
            content = this.createContentElement();
            element.appendChild(content);
        }

        if (this.isEditorRendering) {
            this.renderPlaceholder(content, data);
        } else {
            content.innerHTML = data.html;
            this.executeScripts(content);
        }

        this.renderChatSnippet(element, data);
        this.renderStyles(element, data);

        return element;
    }

    private renderPlaceholder(content: HTMLElement, data: IChatWidgetData): void {
        this.cleanupChatContainer(content);

        if (!data.channelId || data.widgetType === "Embedded" && !data.iframeSrc) {
            const wrapper = document.createElement("div");
            wrapper.classList.add("not-available");
            content.appendChild(wrapper);
            return;
        }

        const wrapper = document.createElement("div");
        wrapper.classList.add("truchat", "custom");

        if (data.widgetType === "Embedded") {
            const iframe = document.createElement("iframe");
            iframe.classList.add("truchat-iframe");
            iframe.src = data.iframeSrc;
            wrapper.appendChild(iframe);
        } else if (data.widgetType === "Popup") {
            wrapper.classList.add("popup-placeholder");
        }
        content.appendChild(wrapper);
    }

    private cleanupChatContainer(chatContainer: HTMLElement): void {
        while (chatContainer.firstChild) {
            chatContainer.removeChild(chatContainer.firstChild);
        }
    }

    private renderChatSnippet(element: HTMLElement, snippet: IChatWidgetData): void {
        element.classList.toggle("not-linked", !snippet.channelId);
        element.dataset.channelId = snippet.channelId;
        element.dataset.renderedHtml = snippet.html;
        element.dataset.iframeSrc = snippet.iframeSrc;
        element.dataset.widgetType = snippet.widgetType;
    }

    protected renderStyles(element: HTMLElement, data: IChatWidgetData): void {
        if (data.widgetType === "Popup") {
            element.style.removeProperty("min-height");
        }

        this.renderBaseStyles(element, data.style);
    }

    private renderBaseStyles(element: HTMLElement, style: IChatWidgetStyle | null): void {
        if (style?.heightData?.height) {
            const elementHeight = `${style.heightData.height}px`;
            element.style.height = elementHeight;
            element.style.minHeight = elementHeight;
        } else {
            const elementHeight = "32px";
            element.style.height = elementHeight;
            element.style.minHeight = elementHeight;
        }
        this.animationRenderer.setAnimationStyles(element, style?.animation);
    }

    protected getContentSelectorsInternal(element: HTMLElement): Array<string> {
        return [`#${element.id}`];
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected cleanupInternal(element: HTMLElement): void {
        // nothing
    }

}
